goog.provide("shadow.js.shim.module$ol$View");
goog.provide("module$shadow_js_shim_module$ol$View");
shadow.js.shim.module$ol$View = shadow.js.nativeProvides["ol/View"] = shadow$bridge("ol/View");
module$shadow_js_shim_module$ol$View.default = shadow.js.shim.module$ol$View;
